import { CalendarIcon } from "@signet/ui";
import { defineWebModule } from "@signet/web-kit";
import { ExpiriesNowTop } from "./now-top.tsx";
import { ExpiriesPage } from "./page.tsx";
import "./expiries.css";

/* The web half of Expiries: its page, and a strip at the very top of Now while something is about to run out. */

const str = (value: unknown) => (typeof value === "string" && value ? value : undefined);

export default defineWebModule({
  id: "expiries",
  nav: { label: "Expiries", icon: CalendarIcon, to: "/expiries", needs: "expiries.item:view" },
  routes: [{ path: "/expiries", component: ExpiriesPage, needs: "expiries.item:view", validateSearch: (raw) => ({ focus: str(raw.focus) }) }],
  nowTop: [{ id: "expiries.soon", needs: "expiries.item:view", order: 10, component: ExpiriesNowTop }],
  commands: [
    { id: "expiries.page", label: "Expiries", to: "/expiries", needs: "expiries.item:view", hint: "Recurring payments", keywords: "expiry subscriptions renewals bills payments due" },
  ],
});
